
import dataHandler from "@/libs/dataHandler";

const permit = {
  namespaced: true,
  state: {
    items: [],
  },
  getters: {},
  mutations: {
    upsertItem(state, item) {
      state.items = dataHandler.upsertItem(
        [...state.items],
        item,
        "id"
      );
    },
    deleteItem(state, id) {
      state.items = dataHandler.deleteItem(state.items, id, "id");
    },
    bulkItems(state, items) {
      state.items = dataHandler.bulkItems(state.items, items, "id");
    },
  },
  actions: {
    upsertItem({ commit }, item) {
      commit("upsertItem", item);
    },
    deleteItem({ commit }, id) {
      commit("deleteItem", id);
    },
    bulkItems({ commit }, items) {
      commit("bulkItems", items);
    },
  },
};

export { permit };
